import {createReducer, on} from '@ngrx/store';
import {createEntityAdapter, EntityAdapter, EntityState} from '@ngrx/entity';
import {FormResponse} from './form-response.model';
import * as FormResponseActions from './form-response.actions';

export const formResponsesFeatureKey = 'formResponses';

export interface State extends EntityState<FormResponse> {
  // additional entities state properties
}

export const adapter: EntityAdapter<FormResponse> = createEntityAdapter<FormResponse>();

export const initialState: State = adapter.getInitialState({
  // additional entity state properties
});

export const reducer = createReducer(
  initialState,
  on(FormResponseActions.addFormResponse,
    (state, action) => adapter.addOne(action.formResponse, state)
  ),
  on(FormResponseActions.upsertFormResponse,
    (state, action) => adapter.upsertOne(action.formResponse, state)
  ),
  on(FormResponseActions.addFormResponses,
    (state, action) => adapter.addMany(action.formResponses, state)
  ),
  on(FormResponseActions.upsertFormResponses,
    (state, action) => adapter.upsertMany(action.formResponses, state)
  ),
  on(FormResponseActions.updateFormResponse,
    (state, action) => adapter.updateOne(action.formResponse, state)
  ),
  on(FormResponseActions.updateFormResponses,
    (state, action) => adapter.updateMany(action.formResponses, state)
  ),
  on(FormResponseActions.deleteFormResponse,
    (state, action) => adapter.removeOne(action.id, state)
  ),
  on(FormResponseActions.deleteFormResponses,
    (state, action) => adapter.removeMany(action.ids, state)
  ),
  on(FormResponseActions.loadFormResponses,
    (state, action) => adapter.setAll(action.formResponses, state)
  ),
  on(FormResponseActions.clearFormResponses,
    state => adapter.removeAll(state)
  ),
);

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapter.getSelectors();
